import React from 'react';
import { Form } from 'react-bootstrap';
import {registerLocale} from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import sv from "date-fns/locale/sv";
registerLocale("sv", sv);

class VBDatePicker extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      date: this.props.selectedDate || '',
      errorMessage: '',
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.selectedDate !== this.props.selectedDate) {
      this.setState({ date: this.props.selectedDate || '' });
    }
  }

  handleDateChange = (e) => {
    const selectedDate = new Date(e.target.value);

    if (isNaN(selectedDate.getTime())) {
      // Invalid date format
      this.setState({ errorMessage: 'Ogiltigt datumformat' });
    } else {
      this.setState({ date: selectedDate, errorMessage: '' });

      if (this.props.onChange) {
        this.props.onChange(selectedDate);
      }
    }
  };

  formatDate(date) {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Ensure double-digit month
    const day = date.getDate().toString().padStart(2, '0'); // Ensure double-digit day
    return `${year}-${month}-${day}`;
  }
  
  render() {
    return (
      <div className="vb-datePicker">
        <Form.Control
          type="date"
          name="datepic"
          placeholder="DateRange"
          value={this.state.date ? this.formatDate(this.state.date) : ''}// Format date for input type="date"
          onChange={this.handleDateChange}
        />
        {this.state.errorMessage && (
        <p className="red-alert">{this.state.errorMessage}</p>
      )}
      </div>
    );
  }
}

export default VBDatePicker;

